export default __webpack_public_path__ + "static/3-96c8c2ad8f64f7389b9a1d0138719ef4.png";